import { type ReactNode } from 'react'

import { ButtonDefault } from '@/components/common/Button'
import { useCardsphereExport } from '@/hooks/useCardsphereExport'

import { type ClipboardBuyButtonType } from '../ClipboardBuyLinksButton'

type Props = {
  buttonProps: ClipboardBuyButtonType
  children: ReactNode
  decklist: string[]
  onTrack: (label: string) => void
}

export const ClipboardBuyLinksButtonCardsphere = ({ buttonProps, children, decklist, onTrack }: Props) => {
  const { loading, onClick } = useCardsphereExport({ decklist, medium: 'clipboard', onTrack })

  return (
    <ButtonDefault {...buttonProps} disabled={decklist.length < 1 || loading} loading={loading} onClick={onClick}>
      {children}
    </ButtonDefault>
  )
}
